import HttpClient from "./../../../core/HttpClient";
import { IPlan } from "./plan.interface";

export class PlanService {
  private httpClient: HttpClient<IPlan>;
  constructor() {
    this.httpClient = new HttpClient<IPlan>();
  }
  public getPlans(): Promise<IPlan[]> {
    return this.httpClient.get<IPlan[]>("/plan");
  }

}